// a topN panel component, which shows how the LLM selects one of the top N predictions
// one row is selected, and the rest are shown as alternatives

import React from 'react'
import styles from './SmartTextArea.module.scss'
import classes from 'classnames'

export default function TopNPanel({topN,selectedTopNIndex, isTopNPanelOpen}) {

  if (!topN || !topN.length) {
    return null
  }

  return (
      <div className={classes({
        [styles.topNPanel]: true,
        [styles.isHidden]: !isTopNPanelOpen,
        [styles.isVisible]: isTopNPanelOpen
      })}>
        {topN.map((item, index) => (
          <span key={index} className={index === selectedTopNIndex ? styles.selected : styles.unselected}>
              {item}
            </span>
        ))}
      </div>
  )
}
